import {
  seekbusiness_com_au,
  qa_seekbusiness_com_au,
  AuthN,
} from '@seek/online-identity';
import Cookies from 'js-cookie';

import { configValues } from 'src/config';

type GetToken = () => Promise<string | void>;

let authN: AuthN;

export const initialiseAuthClient = (): GetToken => {
  const config =
    configValues.ENVIRONMENT === 'production'
      ? seekbusiness_com_au
      : qa_seekbusiness_com_au;

  authN = new AuthN(config);

  const mockAuthCookieToken = Cookies.get('MOCK_USER_AUTH');
  return typeof mockAuthCookieToken === 'string' &&
    mockAuthCookieToken.length > 0
    ? () => Promise.resolve(mockAuthCookieToken)
    : () => authN.getToken();
};
